<template>
	<div>
        <div class="col-md-12 application-form">
			<div class="row" style="margin-top: 25px;">
				<div class="col-md-12 xs-text-center">
					<img v-if="logoSrc" :src="logoSrc" style="width: 250px;" />
					<h3 class="text-left xs-text-center">
						<strong>{{ districtName }}</strong>
					</h3>
				</div>
				
				<div class="col-md-12">
					<h3 class="text-left xs-text-center">
						Sapphire Community Portal Application
					</h3>
				</div>
			</div>
            <div class="alert alert-info" v-html="instructions"></div>
            
            <form method="post" ref="form" @submit.prevent="validateBeforeSubmit" :action="'index.cfm/create-account'">
				<input type="hidden" name="_csrftoken" :value="csrfToken" />
				<input type="hidden" name="account_type" :value="accountType">
                <input type="hidden" name="formData" v-model="getDataOut"/>
                <fieldset class="margin-bottom-20">
                    <legend>Family Contact Information</legend>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('firstName') }">
                                <label class="control-label" for="firstName">First Name:*</label>
                                <input 
                                    type="text"
									maxlength="50"
                                    name="firstName" 
                                    class="form-control" 
                                    placeholder="ex: John"
									data-vv-as="first name"
                                    v-model="contact.firstName"
                                    v-validate="'required'">
                                <div v-show="errors.has( 'firstName' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'firstName' ) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('lastName') }">
                                <label class="control-label" for="lastName">Last Name:*</label>
                                <input 
                                    type="text"
									maxlength="50"
                                    name="lastName" 
                                    class="form-control" 
                                    placeholder="ex: Smith"
                                    v-model="contact.lastName"
									data-vv-as="last name"
                                    v-validate="'required'">
                                <div v-show="errors.has( 'lastName' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'lastName' ) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('relation') }">
                                <label for="relation">Relation:*</label>
								<input 
									type="text"
									maxlength="100"
									class="form-control" 
									name="relation"
									v-model="contact.relation"
									data-vv-as="relation"
                                    v-validate="'required'"
									placeholder="ex: Parent, Guardian, Custodian, Foster Parent"
									v-if="accountType !== 'student'">
								<input 
									type="text"
									maxlength="100"
									class="form-control" 
									name="relation"
									v-model="contact.relation"
									data-vv-as="relation"
                                    v-validate="'required'"
									readonly="true"
									v-else>

                                <div v-show="errors.has( 'relation' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'relation' ) }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('address1') }">
                                <label class="control-label" for="address1">Address 1:*</label>
                                <input 
                                    type="text" 
									maxlength="100"
                                    name="address1"
                                    class="form-control"
                                    v-model="contact.address1"
									data-vv-as="address 1"
                                    v-validate="'required'">
								<div v-show="errors.has( 'address1' )">
                                	<small class="control-label invalid-feedback">{{ errors.first( 'address1' ) }}</small>
                            	</div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has('address2') }">
                                <label class="control-label" for="address2">Address 2:</label>
                                <input 
                                    type="text"
									maxlength="100"
                                    name="address2"
                                    class="form-control"
                                    v-model="contact.address2"
									data-vv-as="address 2"
									>
                                <div v-show="errors.has( 'address2' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'address2' ) }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('city') }">
                                <label class="control-label" for="city">City:*</label>
                                <input 
                                    type="text"
									maxlength="50"
                                    name="city"
                                    class="form-control"
                                    v-model="contact.city"
									data-vv-as="city"
                                    v-validate="'required'">
                                <div v-show="errors.has( 'city' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'city' ) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="control-label form-group" :class="{'has-error': errors.has('zip') }">
                                <label
									class="control-label"
                                    for="zip">ZIP Code:*</label>
                                <input 
                                    type="text"
									maxlength="10"
                                    name="zip"
                                    class="form-control"
                                    v-model="contact.zip"
									data-vv-as="zip"
                                    v-validate="'required'">
                                <div v-show="errors.has( 'zip' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'zip' ) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('state') }">
                                <label class="control-label" for="state">State:*</label>
                                <select 
                                    class="form-control" 
                                    name="state"
                                    v-model="contact.state"
									data-vv-as="state"
                                    v-validate="'required'">
                                    <option 
                                        v-for="state in states" 
                                        :value="state.STATE_CODE">
                                            {{ state.STATE_DESC }}
                                    </option>
                                </select>
                                <div v-show="errors.has( 'state' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'state' ) }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
						<div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has(`homePhone`) }">
								<label class="control-label" :for="`homePhone`">Home Phone: *</label>
								<input 
									type="tel"
									maxlength="20"
									name="homePhone" 
									class="form-control"
									v-model="contact.homePhone"
									v-validate="'required'"
									data-vv-as="Phone and Type"
									placeholder="Enter number">
								<div v-show="errors.has( 'homePhone' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'homePhone' ) }}</small>
                                </div>
							</div>
						</div>

						<div class="col-sm-4">
							<div class="form-group">
								<label :for="`cellPhone`">Cell Phone: </label>
								<input 
									type="tel"
									maxlength="20"
									:name="`cellPhone`" 
									class="form-control"
									v-model="contact.cellPhone"
									placeholder="Enter number">
							</div>
						</div>

						<div class="col-sm-4">
							<div class="form-group">
								<label :for="`cellPhone`">Work Phone: </label>
								<input 
									type="tel"
									maxlength="20"
									:name="`workPhone`" 
									class="form-control"
									v-model="contact.workPhone"
									placeholder="Enter number">
							</div>
						</div>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group" :class="{'has-error': errors.has(`email`) }">
                                <label class="control-label" for="email">
                                    Email: 
                                    <span>*</span>
                                </label>
                                <input 
                                    type="email"
									maxlength="100"
                                    name="email" 
                                    class="form-control"
                                    v-model="contact.email"
                                    v-validate="'required'"
                                    placeholder="Enter an email address">
                                
                                <div v-show="errors.has( `email` )">
                                    <small class="control-label invalid-feedback">{{ errors.first( `email` ) }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="margin-bottom-20">
                    <legend>
                        {{ legendTitle }}
                    </legend>
                    <div class="row ">
                        <div class="child-info-container col-md-4 col-sm-6 col-xs-12" 
                            v-for="( child, c ) in children" 
                            :key="`child-${child.num}`">
							<div class="child-info-inner-wrap">
								<i class="fas fa-times-circle fa-2x" 
									v-if="children.length> 1"
									@click="removeChild( child )"></i>
								<div>
									<div class="form-group" :class="{ 'has-error': errors.has( `child-${child.num}-firstName` ) }" v-if="accountType !== 'student'">
										<label class="control-label">First Name:*</label>
										<input 
											type="text"
											maxlength="40"
											:name="`child-${child.num}-firstName`" 
											class="form-control"
											v-model="child.firstName"
											data-vv-as="first name"
											v-validate="'required'">
										<div v-show="errors.has( `child-${child.num}-firstName` )">
											<small class="control-label invalid-feedback">{{ errors.first( `child-${child.num}-firstName` ) }}</small>
										</div>
									</div>
									<div class="form-group" :class="{'has-error': errors.has( `child-${child.num}-lastName` ) }" v-if="accountType !== 'student'">
										<label class="control-label">Last Name:*</label>
										<input 
											type="text"
											maxlength="40"
											:name="`child-${child.num}-lastName`" 
											class="form-control"
											data-vv-as="last name"
											v-model="child.lastName"
											v-validate="'required'">
										<div v-show="errors.has( `child-${child.num}-lastName` )">
											<small class="control-label invalid-feedback">{{ errors.first( `child-${child.num}-lastName` ) }}</small>
										</div>
									</div>
									<div class="form-group" :class="{'has-error': errors.has( `child-${child.num}-birthDate` ) }">
										<label class="control-label">Date of Birth:*</label>
										<date-picker 
											v-model="children[c].birthDate"
											format="MM/DD/YYYY"
											v-validate=" 'required|date_format:mm/dd/yyyy'"
											data-vv-as="birth date"
											lang="en"
											width="100%"
											:name="`child-${child.num}-birthDate`"></date-picker>
										<div v-show="errors.has( `child-${child.num}-birthDate` )">
											<small class="control-label invalid-feedback">{{ errors.first( `child-${child.num}-birthDate` ) }}</small>
										</div>
									</div>
									<div class="form-group" :class="{'has-error': errors.has( `child-${child.num}-grade` ) }">
										<label class="control-label">Grade:*</label>
										<select 
											class="form-control" 
											:name="`child-${child.num}-grade`"
											data-vv-as="grade"
											v-validate="'required'"
											v-model="child.grade">
											<option v-for="grade in districtGradelevels" :key="grade.GRADE_LEVEL" :value="grade.GRADE_LEVEL">{{grade.GRADE_LEVEL}}</option>
										</select>
										<div v-show="errors.has( `child-${child.num}-grade` )">
											<small class="control-label invalid-feedback">{{ errors.first( `child-${child.num}-grade` ) }}</small>
										</div>
									</div>
									<div class="form-group" :class="{'has-error': errors.has( `child-${child.num}-school` ) }">
										<label class="control-label">School:*</label>
										<select 
											class="form-control" 
											:name="`child-${child.num}-school`"
											data-vv-as="school"
											v-validate="'required'"
											v-model="child.school">
											<option v-for="school in districtSchools" :key="school.SCHOOL_ID" :value="school.SCHOOL_ID">{{school.SCHOOL_TITLE}}</option>
										</select>
										<div v-show="errors.has( `child-${child.num}-school` )">
											<small class="control-label invalid-feedback">{{ errors.first( `child-${child.num}-school` ) }}</small>
										</div>
									</div>
								</div>
							</div>
                        </div>
                        <div class="add-item-container col-md-4 col-sm-6 col-xs-12" v-if="accountType !== 'student'">
                            <i class="fas fa-3x fa-plus-circle add-item-btn" @click="addChild()" style="margin: 6px" title="Add Child"></i><p>Add a Child</p>
                        </div>
                        
                    </div>    
                    
                </fieldset>
                
                <fieldset class="margin-bottom-20">
                    <legend>Login Information </legend>
                    <p>
                        (You will be required to know your Username and Password to access to your child's information.)
                    </p>
                    <div class="row margin-bottom-20">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('username') }">
                                <label
									class="control-label" 
                                    for="userName">Username:*</label>
                                <input 
                                    type="text"
									maxlength="500"
                                    name="username" 
                                    class="form-control"
                                    v-model="acct.username"
                                    v-validate="'required'"
                                    @input="searchTimeOut()"
                                    autocomplete="off">
                                <div v-show="errors.has( 'username' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'username' ) }}</small>
                                </div>
                                <small v-if="!!usernameResp.message" 
                                    :class="{ 	'help-block': true, 
                                                'text-success': usernameResp.status === 'OK',
                                                'text-danger': usernameResp.status !== 'OK' 
                                            }"
                                >*{{usernameResp.message}}</small>
                                <small v-else-if="acct.username.length > 0" class="help-block"><i class="fas fa-spinner fa-spin"></i></small>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('password') }">
                                <label class="control-label" for="Assignment Code Help">Password:*</label>
                                <password
									name="password"
                                    ref="password" 
                                    class="password-input"
                                    v-model="acct.password"
                                    v-validate="'required'"
									:toggle="true"
									:secureLength="passwordMinLegth"
									:showStrengthMeter="true"
									autocomplete="new-password"
									maxlength="40"
								/>
                                <div v-show="errors.has( 'password' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'password' ) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('password2') }">
                                <label class="control-label" for="password2">Confirm Password:*</label>
                                <password
									name="password2"
                                    ref="password2" 
                                    class="password-input"
                                    v-model="acct.password2"
                                    v-validate="'required'"
                                    data-vv-as="confirm password"
									:toggle="true"
									:secureLength="passwordMinLegth"
									:showStrengthMeter="true"
									autocomplete="new-password"
									maxlength="40"
								/>
                                <div v-show="errors.has( 'password2' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'password2' ) }}</small>
                                </div>
                                <small v-if="passwordMessage > 0" class="help-block text-danger" >
									<span v-if="passwordMessage === 1">
										Password must must have the following characteristics: 
										<ul>
											<li>At least {{passwordMinLegth}} characters - the more characters, the better.</li>
											<li>A mixture of letters and numbers.</li>
										</ul>	
									</span>
									
									<span v-if="passwordMessage === 2">Confirm password does not match</span>
									
								</small>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label for="securityQuestSelect">Sample Security Questions:</label>
                                <select 
                                    class="form-control" 
                                    name="sampleQuestions"
                                    @change="populateQuestion"
                                    v-model="acct.selectedSampleQuestion">
										<option value="">Select a question</option>
                                        <option 
                                            v-for="question in sampleQuestions"
                                            :value="question.QUESTION_ID">
                                                {{ question.QUESTION_TEXT }}
                                        </option>
										<option value="">&lt;Create your own question&gt;</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('securityQuestion') }">
                                <label class="control-label" for="securityQuestion">Security Question:*</label>
                                <input 
                                    type="text"
									maxlength="100"
                                    name="securityQuestion"
                                    class="form-control"
									data-vv-as="security question"
									v-validate="'required'"
									placeholder="Select question from list or create your own"
                                    v-model="acct.securityQuestion">
                                <div v-show="errors.has( 'securityQuestion' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'securityQuestion' ) }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('securityAnswer') }">
                                <label
									class="control-label"
                                    for="securityAnswer">Security Answer:*</label>
                                <input 
                                    type="text"
									maxlength="100"
                                    name="securityAnswer"
                                    class="form-control"
									data-vv-as="security answer"
									v-validate="'required'"
                                    v-model="acct.securityAnswer">
                                <div v-show="errors.has( 'securityAnswer' )">
                                    <small class="control-label invalid-feedback">{{ errors.first( 'securityAnswer' ) }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <!-- display messages -->
                <div v-if="getActiveMessage"
                    id="formFeedback"
                    :class="getMessageClass">
                        {{ getActiveMessage.content }}
                </div>

                <div class="center-content-div">
                    <button 
                        type="submit" 
                        :class="{'btn btn-block' : true, 'btn-primary':!isFormInvalid}"
                        :disabled="isFormInvalid">
                        Continue
                    </button>
                    <div class="go-back">
                        <a href="index.cfm/user-policy" @click.prevent.stop="$refs.backForm.submit();"><i class="fas fa-chevron-left"></i> Go Back</a>
                    </div>
                </div>
                
            </form>
			<form method="post" ref="backForm" :action="'index.cfm/user-policy'">
				<input type="hidden" name="_csrftoken" :value="csrfToken" />
			</form>
        </div>
    </div>
    
</template>

<script>
    import DatePicker from '../../DatePicker.vue';
    import Password from 'vue-password-strength-meter'
	import moment from 'moment';

    export default{
        props:{
			districtName : "",
			logoSrc : "",
			instructions: "",
            csrfToken : "",
            csrfTokenUser:"",
			districtSchools : {},
			districtGradelevels : {
				type: Array,
				required: true
			},
			accountType: {
				type: String,
				required: true
			},
			districtStateCode: {
				type: String,
				required: true
			},
        	states : {
        		type: Array,
				required: true
			},
            sampleQuestions : {
                    type: Array,
                    required : true
            },
        	message : {
        		type: Object,
				default: function(){
					return {
						category: "info",
						content: "Please complete the form, then click Continue"
					}
				}
            },
            entrypoint : {
				type: String,
				required: true
			}
        },
        components: { DatePicker, Password },
        data(){
            return{
            	selectedDistrictId: "",
            	selectedDistrict: {},
            	selectedSchool: "",
				selectedYear: "",
                newChild:{
                    num: 0,
                    firstName: "",
                    lastName: "",
                    birthDate: "",
                    grade: "",
                    school: ""
                },
                newPhone:{
                    num: 0,
                    number: "",
                    type: ""
                },
                newEmail:{
                    num:0,
                    address: ""
                },
                contact:{
                    firstName : "",
                    lastName : "",
                    relation: "",
                    address1: "",
                    address2: "",
                    city: "",
                    state: this.districtStateCode,
                    zip:"",
                    phones: [],
                    emails: ""
                },
                children: [],
                acct:{
                    username:"",
                    password: "",
                    password2:"",
                    selectedSampleQuestion: "",
                    securityQuestion: "",
                    securityAnswer:""
                },
                usernameResp:{},
                timer:null,
                passwordMinLegth:8
            }
        },
        computed: {
            passwordMessage(){
				let alpha = /[a-zA-Z]/,
				number = /[0-9]/,
				minLength = this.passwordMinLegth;
				/* check length */
				if(this.acct.password.length < minLength){
					return 1;
				}
				/* Check A mixture of letters and numbers */
				else if(!alpha.test(this.acct.password) || !number.test(this.acct.password)){
					return 1;
				}
				/* Make sure confirm password matches */
				else if(this.acct.password !== this.acct.password2){
					return 2;
				}
				/* else basic check password change is good */
				return 0;
			},
			legendTitle() {
				return this.accountType === 'student' ? 'Student Information' : 'Children Information';
			},
			getDataOut() {
				for(let i in this.children ){
					let child = this.children[i];
					child.birthDate = moment(String(child.birthDate)).format('MM/DD/YYYY');
				}

				var dataOut = {
					contactData : this.contact,
					childData : this.children,
					acctData: this.acct
				}
				return JSON.stringify( dataOut );
			},
    		isFormInvalid() {
                  return Object.keys( this.fields ).some( key => this.fields[ key ].invalid )
                        || !this.usernameResp.hasOwnProperty("status")
                        || this.usernameResp.status !== "OK"
                        || this.passwordMessage !== 0;
    		},
    		isFormTouched() {
    			return Object.keys( this.fields ).some( key => this.fields[ key ].touched );
    		},
    		getMessageClass() {
    			return "alert alert-" + this.getActiveMessage.category;
    		},
    		getActiveMessage() {
    			if( this.isFormInvalid && this.isFormTouched ){
    				return {
    					category : "warning",
    					content : "Some required fields are missing!"
    				}
    			} else{
    				return this.message;
    			}
    		},
            requireOne() {
                return ( this.contact.phones.length && ! this.contact.phones[0].number.length ) ? 'required' : ''
            }
  		},
        methods: {
            addChild(){
                this.newChild.num += 1;
                this.children.push( JSON.parse( JSON.stringify( this.newChild ) ) );
            },
            removeChild( child ){
                if( this.children.length > 1 ){
                    this.children.splice( this.children.map( child => { return child.num }).indexOf( child.num ), 1 );
                }
            },
            addPhone(){
                this.newPhone.num += 1;
                this.contact.phones.push( JSON.parse( JSON.stringify( this.newPhone ) ) );
            },
            removePhone( phone ){
                if( this.contact.phones.length > 1 ){
                    this.contact.phones.splice( this.contact.phones.map( phone => { return phone.num }).indexOf( phone.num ), 1 );
                }
            },
            addEmail(){
                this.newEmail.num += 1;
                this.contact.emails.push( JSON.parse( JSON.stringify( this.newEmail ) ) );
            },
            removeEmail( email ){
                if( this.contact.emails.length > 1 ){
                    this.contact.emails.splice( this.contact.emails.map( email => { return email.num }).indexOf( email.num ), 1 );
                }
            },
            populateQuestion(){
                this.acct.securityQuestion = JSON.parse( JSON.stringify( 
                    this.sampleQuestions.filter( q => { 
                        return q.QUESTION_ID == this.acct.selectedSampleQuestion 
                    } )[ 0 ].QUESTION_TEXT ) );
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
	                if (result) {
	                    this.$refs.form.submit();
	                }
            	});
            },
            searchTimeOut() {  
				this.usernameResp = {};
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.timer = setTimeout(() => {
					this.isCWPUsernameTaken()
				}, 800);
			},
			isCWPUsernameTaken() {
				/* clean out any whitespace */
				this.acct.username = this.acct.username.replace(/\s+/g, '');
				/* if blank stop */
				if(!this.acct.username){
					return;
                }
                
                let payload = {
                    'new_username': this.acct.username,
                    '_csrftoken' : this.csrfTokenUser
                };
                const _self = this;
                $.post("/CommunityWebPortal/_auth/index.cfm/check-user", payload,function(){},'json')
                .done(function(data){
                    _self.usernameResp = data;
                });


				
			}
        },
        created(){
            // populate first item in dynamic fields
            if( this.accountType === 'student') {
                this.contact.relation = 'Student';
            }
            this.addChild();
            this.addPhone();
            this.isCWPUsernameTaken();
        }  
    }
</script>